// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"2a59c3ee","72":"fdfce0da","213":"dbdc7858","453":"cb059362","788":"f9a23300"}[chunkId] + ".chunk.js";
};